import React, { FC } from 'react';
import classNames from 'classnames/bind';

import { Unit } from '../Unit';
import { Accumulate } from '../Accumulate';
import styles from './styles.pcss';
import { CountProps } from './types';

const cn = classNames.bind(styles);

export const Count: FC<CountProps> = ({
  isUnlimited,
  isLow,
  className,
  rest,
  size,
  displayUnit,
  description,
}) => (
  <div className={cn('component', className)}>
    <Accumulate
      isLow={isLow}
      isUnlimited={isUnlimited}
      rest={rest?.toLocaleString()}
      size={size?.toLocaleString()}
    />
    <Unit description={description} unit={displayUnit} />
  </div>
);
